import { render } from "./DeviceDetails.vue?vue&type=template&id=5b53f42e&scoped=true"
import script from "./DeviceDetails.vue?vue&type=script&lang=js"
export * from "./DeviceDetails.vue?vue&type=script&lang=js"

import "./DeviceDetails.vue?vue&type=style&index=0&id=5b53f42e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b53f42e"]])

export default __exports__